let antiForgeryToken = {};

antiForgeryToken.set = function(initData) {
    antiForgeryToken._value = initData.antiForgeryToken;
};

antiForgeryToken.get = function() {
    return antiForgeryToken._value;
};

antiForgeryToken.addToAjaxRequest = function(options) {
    options.headers = options.headers || {};
    options.headers['X-XSRF-Token'] = antiForgeryToken._value;
};

export default antiForgeryToken;
